import React from 'react';
import { motion } from 'framer-motion';
import { Sign } from '../../data/signs';
import { ParticleField } from '../shared/ParticleField';
import { startCheckout } from '../../lib/metaPixel';
interface SignHeroProps {
  sign: Sign;
}
export function SignHero({
  sign
}: SignHeroProps) {
  return <section className="relative w-full min-h-screen flex items-center justify-center overflow-hidden" style={{
    background: `linear-gradient(135deg, ${sign.colors.primary}20 0%, ${sign.colors.secondary}10 50%, #050508 100%)`
  }} data-id="element-363">
      <ParticleField type={sign.particleType} color={sign.colors.primary} density={50} data-id="element-364" />

      {/* Background image with overlay */}
      <div className="absolute inset-0" data-id="element-365">
        <img src={sign.imageUrl} alt={sign.entidad} className="w-full h-full object-cover opacity-55" loading="eager" data-id="element-366" />
        <div className="absolute inset-0" style={{
        background: `linear-gradient(180deg, rgba(5,5,8,0.55) 0%, ${sign.colors.primary}25 50%, rgba(5,5,8,0.92) 100%)`
      }} data-id="element-367" />
        <div className="absolute inset-0" style={{
        background: `radial-gradient(circle at center, transparent 0%, ${sign.colors.primary}15 40%, rgba(5,5,8,0.8) 100%)`
      }} data-id="element-368" />
      </div>

      <div className="relative z-10 text-center px-6 max-w-5xl" data-id="element-369">
        <motion.h1 initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1,
        delay: 0.2
      }} className="text-6xl md:text-8xl font-serif font-bold mb-4 tracking-wide" style={{
        color: '#FFFFFF',
        textShadow: `0 0 60px ${sign.colors.primary}80, 0 4px 30px rgba(0,0,0,0.9)`
      }} data-id="element-370">
          {sign.name}
        </motion.h1>

        {/* Small zodiac symbol below name */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.5
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8,
        delay: 0.5
      }} className="mb-6" data-id="element-371">
          <span className="inline-block text-5xl md:text-6xl" style={{
          color: sign.colors.primary,
          textShadow: `0 0 30px ${sign.colors.primary}, 0 0 60px ${sign.colors.primary}80`
        }} data-id="element-372">
            {sign.symbol}
          </span>
        </motion.div>

        <motion.p initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 1,
        delay: 0.7
      }} className="text-2xl md:text-3xl font-serif text-gray-100 mb-4" style={{
        textShadow: '0 2px 20px rgba(0,0,0,0.9)'
      }} data-id="element-373">
          {sign.arquetipo}
        </motion.p>

        <motion.p initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 1,
        delay: 0.9
      }} className="text-lg md:text-xl italic mb-12" style={{
        color: sign.colors.accent,
        textShadow: '0 2px 20px rgba(0,0,0,0.9)'
      }} data-id="element-374">
          "{sign.phrase}"
        </motion.p>

        <motion.button onClick={() => startCheckout(sign.name, sign.checkoutUrl, 9.99)} initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1,
        delay: 1.1
      }} className="inline-block px-10 py-5 text-lg font-bold rounded-lg transition-all duration-300" style={{
        backgroundColor: sign.colors.primary,
        color: '#050508',
        boxShadow: `0 0 40px ${sign.colors.primary}60`
      }} whileHover={{
        scale: 1.05,
        boxShadow: `0 0 60px ${sign.colors.primary}90`
      }} whileTap={{
        scale: 0.95
      }} data-id="element-375">
          Desbloquear Núcleo {sign.name} — $9.99
        </motion.button>
      </div>
    </section>;
}